export default {
  routes: (_routes) => {
    // Add Indonesian routes
    const indonesianRoutes = [
      {
        name: 'id-index',
        path: '/id',
        component: () => import('~/pages/index.vue')
      },
      {
        name: 'id-services',
        path: '/id/services',
        component: () => import('~/pages/services.vue')
      },
      {
        name: 'id-case-studies',
        path: '/id/case-studies',
        component: () => import('~/pages/case-studies/index.vue')
      },
      {
        name: 'id-case-studies-vertical',
        path: '/id/case-studies/:vertical',
        component: () => import('~/pages/case-studies/[vertical].vue')
      },
      {
        name: 'id-about-us',
        path: '/id/about-us',
        component: () => import('~/pages/about-us.vue')
      },
      {
        name: 'id-contact-us',
        path: '/id/contact-us',
        component: () => import('~/pages/contact-us.vue')
      }
    ]

    return [..._routes, ...indonesianRoutes]
  }
}